export default __webpack_public_path__ + "document.1faf384ce7b0b8de54ca79ff584cc2e4.svg";